import { put, select, takeLatest } from 'redux-saga/effects';
import { get } from 'lodash';

import { actions as communitiesJoinRequestsActions } from '../communitiesJoinRequests';
import { actions as notificationCountersActions } from '../notificationCounters';
import { currentLocationSelector } from '../../common/selectors';
import { ACTIVITIES, COMMUNITIES } from '../../../constants/routes';
import { ACTIVITY_TYPES } from '../../../constants';
import chatConsts from '../../chatConnection/constants';

const mapTypes = {
  [chatConsts.JOIN_REQUEST_ACCEPTED]: ACTIVITY_TYPES.NOTIFICATIONS,
  [chatConsts.JOIN_REQUEST_DECLINED]: ACTIVITY_TYPES.NOTIFICATIONS,
  [chatConsts.COMMUNITY_INVITE_ACCEPT]: ACTIVITY_TYPES.NOTIFICATIONS,
  [chatConsts.COMMUNITY_INVITE_DECLINE]: ACTIVITY_TYPES.NOTIFICATIONS,
  [chatConsts.NEW_JOIN_REQUEST]: ACTIVITY_TYPES.JOIN_REQUESTS,
  [chatConsts.NEW_COMMUNITY_INVITE]: ACTIVITY_TYPES.MEMBER_INVITATIONS,
};

function* handleRealTimeNotificationInsert({ type: actionType, payload }) {
  const notification = get(payload, 'message.payload.data.notification');
  const currentLocation = yield select(currentLocationSelector);
  const type = mapTypes[actionType];

  yield put(notificationCountersActions.updateActivityCount(1));
  if (notification && currentLocation === `/${COMMUNITIES}/${ACTIVITIES}`) {
    yield put(
      communitiesJoinRequestsActions.realTimeInsert({
        list: [notification],
        type,
      }),
    );
  }
}

export default function* joinRequestNotificationSaga() {
  yield takeLatest(
    [
      chatConsts.JOIN_REQUEST_ACCEPTED,
      chatConsts.JOIN_REQUEST_DECLINED,
      chatConsts.NEW_JOIN_REQUEST,
      chatConsts.NEW_COMMUNITY_INVITE,
      chatConsts.COMMUNITY_INVITE_ACCEPT,
      chatConsts.COMMUNITY_INVITE_DECLINE,
    ],
    handleRealTimeNotificationInsert,
  );
}



// WEBPACK FOOTER //
// ./src/redux/communities/sagas/joinRequestNotification.js